export const isPromotionMultiple = (promotion) => promotion.type === 'MULTI';
